// Copyright (c) 2019 Deere & Company

import t from 'tcomb';

const OktaState = t.struct( {
    accessToken: t.String,
    isAuthenticated: t.maybe( t.Boolean ),
    userFirstName: t.String,
}, 'OktaState' );

export const getDefaultState = () => new OktaState( {
    accessToken: '',
    isAuthenticated: null,
    userFirstName: '',
} );

export default OktaState;
